export enum PermissionState {
  open = 1,
  consistent = 2,
  locked = 3
}
